import React, { useEffect, useState } from "react";
import { Eye, MessageCircle, Edit, MoreHorizontal, Clock, Star, MapPin, Trash, Image } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PromocionesTableComponent({
  data = [],
  metaPaginacion = {},
  onPageChange,
  perPage = 10,
  onPerPageChange,
  handleEditarItem,
  handleOpenModalDelete
}) {

  const navigate = useNavigate();
  const [openImagesMenuId, setOpenImagesMenuId] = useState(null);

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (event.target.closest("[data-images-menu]")) {
        return;
      }
      setOpenImagesMenuId(null);
    };

    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleOpenImagesMenu = (event, itemId) => {
    event.stopPropagation();
    setOpenImagesMenuId((prev) => (prev === itemId ? null : itemId));
  };

  const handleGoToImages = (itemId, mode) => {
    setOpenImagesMenuId(null);
    // navigate(`/app/admin/promocion/agregar-imagen/${itemId}`, {
    //   state: { mode },
    // });

    if (mode === "agregar") {
      navigate(`/app/admin/promocion/agregar-imagen/${itemId}?mode=agregar`);
    } else if (mode === "ordenar-eliminar") {
      navigate(`/app/admin/promocion/agregar-imagen/${itemId}?mode=ordenar-eliminar`);
    }
  };

  const formatDate = (dateString) => {
      const date = new Date(dateString);

      const formatted = date.toLocaleDateString("es-ES", {
          day: "2-digit",
          month: "short",
      });

      return formatted.replace(
          /\b\w/,
          (char) => char.toUpperCase()
      );
  };



  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      {/* Header de la tabla */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Id
              </th>

              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Título
              </th>


              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Imagen
              </th>

              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Fecha del Evento
              </th>

              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Vigencia
              </th>

              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Locales
              </th>




              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {data?.map((item) => (
              <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                {/* Id */}
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-3">
                    <div>
                      <div className="font-medium text-gray-900">{item?.id}</div>
                    </div>
                  </div>
                </td>

                {/* Título */}
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-3">
                    {/* <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center text-white font-semibold text-sm">
                      {item?.titulo?.charAt(0).toUpperCase() || "U"}
                    </div> */}
                    <div>
                      <div className="font-medium text-gray-900">{item?.titulo}</div>
                    </div>
                  </div>
                </td>

                {/* Tipo de Usuario */}
                {/* <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${usuario.tipo_usuario === 'SISTEMA' ? 'bg-purple-100 text-purple-800' :
                    usuario.tipo_usuario === 'COORDINADOR' ? 'bg-blue-100 text-blue-800' :
                      usuario.tipo_usuario === 'DOCTOR' ? 'bg-green-100 text-green-800' :
                        'bg-gray-100 text-gray-800'
                    }`}>
                    {usuario.tipo_usuario}
                  </span>
                </td> */}

                {/* Imagen */}
                <td className="px-6 py-4 whitespace-nowrap">
                  {item?.imagen ? (
                    <img
                      src={item.imagen}
                      alt={item.titulo}
                      className="w-16 h-16 object-cover rounded"
                    />
                  ) : (
                    <div className="w-16 h-16 bg-gray-200 rounded flex items-center justify-center text-gray-500 text-sm">
                      Sin imagen
                    </div>
                  )}
                </td>

                <td className="px-6 py-4 whitespace-nowrap">
                  {item?.vigencia_promocion_desde && item?.vigencia_promocion_hasta ? (
                    <div className="flex items-center gap-1 text-sm text-gray-600">
                      <Clock className="w-4 h-4" />
                      {(() => {
                        const desde = formatDate(item.vigencia_promocion_desde);
                        const hasta = formatDate(item.vigencia_promocion_hasta);

                        return desde === hasta
                          ? desde
                          : `${desde} al ${hasta}`;
                      })()}
                    </div>
                  ) : (
                    <div className="text-sm text-gray-500">Sin vigencia</div>
                  )}
                </td>

                {/* Vigencia */}
                <td className="px-6 py-4 whitespace-nowrap">
                  {item?.vigencia_promocion_app_format && item?.vigencia_promocion_app_format ? (
                    <div className="flex items-center gap-1 text-sm text-gray-600">
                      <Clock className="w-4 h-4" />
                      {item.vigencia_promocion_app_format}
                    </div>
                  ) : (
                    <div className="text-sm text-gray-500">Sin vigencia</div>
                  )}
                </td>

                {/* Locales */}
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-3">
                    <div>
                      {item?.all_locales ? (
                        <div className="font-medium text-gray-900">Todos</div>
                      ) : (
                        <div className="font-medium text-gray-900">{item?.locales?.length || 0}</div>
                      )}
                    
                    </div>
                  </div>
                </td>




                {/* Acciones */}
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-2">

                    <button className="p-1 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer" title="Editar"
                      onClick={() => handleEditarItem(item)}
                    >
                      <Edit className="w-4 h-4 text-gray-500" />
                    </button>

                    <div className="relative" data-images-menu>
                      <button
                        className="inline-flex items-center gap-1.5 px-2 py-1 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer text-sm text-gray-600 bg-blue-50 border border-blue-200"
                        title="Imágenes"
                        onClick={(event) => handleOpenImagesMenu(event, item.id)}
                        aria-expanded={openImagesMenuId === item.id}
                        aria-haspopup="menu"
                      >
                        <Image className="w-4 h-4 text-gray-500" />
                        <span className="font-medium text-gray-600">
                          Imágenes
                        </span>
                      </button>

                      {openImagesMenuId === item.id && (
                        <div className="absolute right-0 top-9 z-20 min-w-[170px] rounded-lg border border-gray-200 bg-white py-1 shadow-lg flex flex-col" role="menu">
                          <button
                            className="block w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                            onClick={() => handleGoToImages(item.id, "agregar")}
                            role="menuitem"
                          >
                            Agregar
                          </button>
                          <button
                            className="block w-full px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                            onClick={() => handleGoToImages(item.id, "ordenar-eliminar")}
                            role="menuitem"
                          >
                            Ordenar/eliminar
                          </button>
                        </div>
                      )}
                    </div>

                    <button className="p-1 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                      title="Eliminar"
                      onClick={() => handleOpenModalDelete(item.id)}
                    >
                      <Trash className="w-4 h-4 text-gray-500" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Si no hay datos */}
      {data.length === 0 && (
        <div className="text-center py-12">
          <div className="text-gray-500">
            No hay promociones para mostrar.
          </div>
        </div>
      )}

      {/* Paginación */}
      {metaPaginacion && metaPaginacion.total > 0 && (
        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
          <div className="flex items-center justify-between">
            {/* Info de página e índice */}
            <div className="flex items-center gap-4">
              <div className="text-sm text-gray-700">
                Mostrando <span className="font-medium">{((metaPaginacion.current_page - 1) * metaPaginacion.per_page) + 1}</span> a{" "}
                <span className="font-medium">
                  {Math.min(metaPaginacion.current_page * metaPaginacion.per_page, metaPaginacion.total)}
                </span> de{" "}
                <span className="font-medium">{metaPaginacion.total}</span> promociones
              </div>

              {/* Selector de cantidad por página */}
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Mostrar:</span>
                <select
                  value={perPage}
                  onChange={(e) => onPerPageChange && onPerPageChange(Number(e.target.value))}
                  className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                <span className="text-sm text-gray-600">por página</span>
              </div>
            </div>

            {/* Índice de páginas y navegación */}
            <div className="flex items-center gap-4">
              {/* Índice de páginas */}
              <div className="text-sm text-gray-700">
                Página <span className="font-medium">{metaPaginacion.current_page}</span> de{" "}
                <span className="font-medium">{metaPaginacion.last_page}</span>
              </div>

              {/* Botones de navegación */}
              <div className="flex items-center gap-2">
                <button
                  onClick={() => onPageChange && onPageChange(1)}
                  disabled={metaPaginacion.current_page === 1}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Primera
                </button>
                <button
                  onClick={() => onPageChange && onPageChange(metaPaginacion.current_page - 1)}
                  disabled={metaPaginacion.current_page === 1}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Anterior
                </button>
                <button
                  onClick={() => onPageChange && onPageChange(metaPaginacion.current_page + 1)}
                  disabled={metaPaginacion.current_page === metaPaginacion.last_page}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Siguiente
                </button>
                <button
                  onClick={() => onPageChange && onPageChange(metaPaginacion.last_page)}
                  disabled={metaPaginacion.current_page === metaPaginacion.last_page}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Última
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}